"use client";

import React from "react";
import { IBlogCarousel } from "@/shared/models/content/blog-article-content";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import { getContentUrl } from "@/lib/api/getUrl";
import { BREAKPOINTS } from "@/shared/constants/breakpoints";
import LightboxGallery from "@/components/LightboxGallery";

type BlogArticleCarouselProps = {
  options: IBlogCarousel;
};

const BlogArticleCarousel: React.FC<BlogArticleCarouselProps> = ({ options }) => {
  return (
    <div className="blog-article__component-carousel">
      <LightboxGallery
        wrapperClassName="blog-article__component-carousel"
        selector=".blog-article__component-carousel-item"
      >
        <Swiper
          spaceBetween={16}
          slidesPerView={1.2}
          slidesOffsetBefore={20}
          slidesOffsetAfter={20}
          role="region"
          aria-label="Blog article image carousel"
          a11y={{
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide"
          }}
          keyboard={{
            enabled: true,
            onlyInViewport: true
          }}
          breakpoints={{
            [BREAKPOINTS.minWidth.lg]: {
              slidesPerView: "auto",
              spaceBetween: 32,
              centeredSlides: true,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            }
          }}
        >
          {options.images.map((image, index) => (
            <SwiperSlide key={index} role="group" aria-label={`${index + 1} of ${options.images.length}`}>
              <button
                type="button"
                className="blog-article__component-carousel-item"
                data-src={getContentUrl(image.url)}
                aria-label={`Open ${image.alternativeText || `blog carousel image ${index + 1}`} in media viewer`}
              >
                <Image
                  src={getContentUrl(image.url)}
                  alt={image.alternativeText || `Blog carousel image ${index + 1}`}
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 60vw, 50vw"
                  style={{ objectFit: "cover" }}
                />
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </LightboxGallery>
    </div>
  );
};

export default BlogArticleCarousel;
